import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleInquiry = () => {
    navigate('/contact');
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container header-inner">
        <div className="logo">
          <Link to="/">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Heaven Green Infra. Landscape" className="logo-image" />
          </Link>
        </div>
        <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
          <span></span><span></span><span></span>
        </button>
        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
          <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/projects" onClick={() => setMenuOpen(false)}>Projects</Link>
          <Link to="/testimonials" onClick={() => setMenuOpen(false)}>Testimonials</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
        </nav>
        <button className="btn-inquiry" onClick={handleInquiry}>Inquiry</button>
      </div>
    </header>
  );
}

export default Header;